(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Dashboard",
                {
                    url: "/Dashboard",
                    component: "dashboard",
                    resolve: {
                        publishedTransactionGroup: ["transactionGroupApi", "transactionGroup", function (transactionGroupApi, transactionGroup) {
                            return transactionGroupApi.getPublishedTransactionGroup(transactionGroup.Id).catch(ng.noop);
                        }],
                        userContext: ["userApi", function (userApi) {
                            return userApi.getContextUserIds();
                        }],
                        onBehalfOfUsers: ["userApi", "userContext", function (userApi, userContext) {
                            return userApi.getUsersForDelegateUser(userContext.ActingUserId);
                        }],
                        dashboardUser: [
                            "userApi", "userContext", function (userApi, userContext) {
                                return userApi.get(userContext.ActingUserId);
                            }]
                    }
                });
        }
    ]);

    app.component("dashboard",
        {
            templateUrl: "/App/Dashboard/dashboard.html",
            controller: dashboardController,
            bindings: {
                transactionGroup: "<",
                publishedTransactionGroup: "<",
                userContext: "<",
                onBehalfOfUsers: "<",
                dashboardUser: "<"
            }
        });

    dashboardController.$inject = ["$state", "$mdDialog", "queueApi", "permissionService", "transactionGroupApi", "userApi", "userDelegateApi", "_", "$filter", "salesForceApi"];

    function dashboardController($state, $mdDialog, queueApi, permissionService, transactionGroupApi, userApi, userDelegateApi, _, $filter, salesForceApi) {
        var $ctrl = this;

        this.$state = $state;
        ng.extend($ctrl,
            {
                configureSystem: configureSystem,
                selectTransactionGroup: selectTransactionGroup,
                permissionService: permissionService,
                getUserReviewQueue: getUserReviewQueue,
                startNewTransaction: startNewTransaction,
                closeDialog: closeDialog,
                getDelegatePermissions: getDelegatePermissions,
                buildViewingList: buildViewingList
            });

        this.$onInit = function () {
            $ctrl.userViewList = [];

            //check if onBehalf of user exists in local storage and use that for instances like page refreshes etc.
            var onBehalfOfUserId = permissionService.getOnBehalfOfUserId();

            $ctrl.viewAsUser = _.find($ctrl.onBehalfOfUsers, function (row) {
                return row.OnBehalfOfUserId === onBehalfOfUserId;
            });

            if ($ctrl.viewAsUser) {
                $ctrl.viewAsUserId = $ctrl.viewAsUser.OnBehalfOfUserId;
            }
            else $ctrl.viewAsUserId = $ctrl.userContext.ActingUserId;

            buildViewingList();
            getDelegatePermissions();
            getUserReviewQueue();
        };

        function buildViewingList() {
            ng.forEach($ctrl.onBehalfOfUsers, function (user) {
                var userView = {
                    Name: user.OnBehalfOfUser.FirstName + " " + user.OnBehalfOfUser.LastName,
                    UserId: user.OnBehalfOfUser.Id
                }

                $ctrl.userViewList.push(userView);
            });

            $ctrl.userViewList = $filter('orderBy')($ctrl.userViewList, "Name");

            var loggedInUserView = {
                Name: "Yourself",
                UserId: $ctrl.userContext.ActingUserId
            }

            $ctrl.userViewList.unshift(loggedInUserView);
        }

        function getDelegatePermissions() {

            var onBehalfOfUser = _.find($ctrl.onBehalfOfUsers, function (row) { return row.OnBehalfOfUserId === $ctrl.viewAsUserId; });

            if (onBehalfOfUser) {
                permissionService.setOnBehalfOfUserId(onBehalfOfUser.OnBehalfOfUserId);

                return userDelegateApi.getUserDelegatePermissions().then(function (permissions) {
                    permissionService.setPermissions(permissions);
                });

            } else {
                permissionService.removeStoredOnBehalfOfUserId();
                return userApi.getCurrentUserPermissions().then(function (permissions) {
                    permissionService.setPermissions(permissions);
                });
            }
        }

        function configureSystem($event) {
            var alert = $mdDialog.show({
                targetEvent: $event,
                controller: "configureTransactionGroupController",
                controllerAs: "$ctrl",
                templateUrl: "/App/Dashboard/ConfigureTransactionGroup/template.html"
            });

            $mdDialog.show(alert);
        }

        function selectTransactionGroup($event) {
            $mdDialog.show({
                targetEvent: $event,
                controller: "configureTransactionGroupAdminController",
                controllerAs: "$ctrl",
                templateUrl: "/App/Dashboard/ConfigureTransactionGroupEntity/template.html",
                clickOutsideToClose: false,
                resolve: {
                    transactionGroups: [
                        "transactionGroupApi", function (transactionGroupApi) {
                            return transactionGroupApi.getTransactionGroups();
                        }
                    ]
                }
            });
        }

        function startNewTransaction($event) {
            
            if ($ctrl.publishedTransactionGroup && $ctrl.publishedTransactionGroup.SubmittedPaperApplicationEmails.length > 0) {    

                if ($ctrl.transactionGroup.Name === "Prospera") {
                    salesForceApi.getExternalSfAdvisor($ctrl.viewAsUserId).then(function (results) {                  
                        if (results !== null) {
                            $state.go("Transaction.Initiate");
                        }
                     
                    }, function (error) {     

                        var errorAlert = $mdDialog.alert({
                            title: "Your account has not been connected to your Salesforce Account.  Please contact your entity's administrator.",
                            ariaLabel: "Error alert",
                            ok: "Ok",
                            skipHide: true
                        });

                        $mdDialog.show(errorAlert);                      
                        });                  
                }

                else $state.go("Transaction.Initiate");

              
            }          
            else
                exitDialog($event);
        }

        function getUserReviewQueue() {
            queueApi.getUserReviewQueue().then(function (data) {
                $ctrl.UserQueue = data;
            });
        };

        function exitDialog($event) {
            var exit = $mdDialog.show({
                contentElement: "#myDialog",
                parent: ng.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true
            });
        };

        function closeDialog() {
            $mdDialog.hide();
        }
    }
})(window.app, window.angular);